import React, {useEffect} from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {cartState, vatType} from "../../state";
import { Box, Text, Button } from "zmp-ui";
import { useNavigate } from "react-router";
import { ListProduct } from "./listProduct";
import {useCartProduct} from "./hooks/useCartProduct";

export const CartItems = ({mode}) => {

   const {func} = useCartProduct()
   useEffect(() => {
      func.getOrderDetail()
   }, [])
   const cart = useRecoilValue(cartState);
   const setCart = useSetRecoilState(cartState);
   const handleQuantityChange = (productId, amount) => {
      if (amount === 0) {
         const newProduct = cart.filter((item) => item.id !== productId);
         setCart(newProduct);
      } else {
         const newProduct = cart.map((item) => {
            if (item.id === productId) {
               return {
                  ...item,
                  quantity: amount > 9999 ? item.quantity : amount,
                  total_price: amount > 9999 ? +item.quantity * +item.price : +amount * +item.price,
               };
            }
            return item;
         });
         setCart(newProduct);
      }
   };
   const nav = useNavigate();

   const handleDeleteCartItem = (detailId) => {
      const newProduct = cart.filter((item) => item.id !== detailId);
      setCart(newProduct);
      func.deleteProductOfOrder(detailId)
   };
   return (
      <Box className={+cart?.length == 0 ? "h-full" : ""}>
         {cart?.length > 0 ? (
            <Box className="product-block">
               <Box
                  flex
                  alignContent="center"
                  justifyContent="space-between"
                  style={{ fontSize: 18, fontWeight: 600, color: "#0F172A"}}
               >
                  <p className="product-block__title flex">
                     Thông tin sản phẩm  {/*(<span style={{ fontWeight: '400' }}>{cart?.length}</span>) */}
                  </p>
               </Box>
               <Box>
                  <ListProduct
                     items={cart}
                     limit={3}
                     quantityChange={handleQuantityChange}
                     onDelete={handleDeleteCartItem}
                     mode={mode}
                  />
               </Box>
            </Box>
         ) : (
            <Box flex justifyContent="center" className="h-full pt-[130px]">
               <Box className="text-center pb-[48px]">
                  <Text
                     className="text-center text-gray"
                     bold={true}
                     size="large"
                     style={{ color: "#0F172A" }}
                  >
                     Chưa có sản phẩm nào
                  </Text>

                  <Text
                     className="text-center text-gray"
                     bold={true}
                     size="small"
                     style={{ color: "#64748B", paddingTop: "4px" }}
                  >
                     Chọn 1 sản phẩm để thêm vào giỏ hàng
                  </Text>

                  <Text
                     className="text-center text-gray"
                     bold={true}
                     size="small"
                     style={{ color: "#64748B" }}
                  >
                     của bạn
                  </Text>

                  <Button className="rounded-lg mt-4" onClick={() => nav("/")}>
                     Mua sắm ngay
                  </Button>
               </Box>
            </Box>
         )}
      </Box>
   );
};
